import {createSelector} from 'reselect';

export const getAppState = (state) => state.appState;
export const userAuthRoleIdSelector = createSelector([getAppState], (appState) => appState?.user?.authRole?.id);
export const userDepartmentIdSelector = createSelector([getAppState], (appState) => appState?.user?.departmentID);
export const userSelector = createSelector([getAppState], (appState) => appState?.user);
export const selectPeriodeAndAuthRole = createSelector([getAppState], (appState) => ({
  currentPeriodId: appState.currentPeriod.id,
  periode: appState?.currentPeriod?.periode,
  userAuthRoleId: appState?.user?.authRole?.id,
}));
export const selectAuthToken = (state) => state.appState.authtoken;
export const selectUser = (state) => state.appState.user;
export const selectMenu = (state) => state.appState.menu;
export const selectSWVersion = (state) => state.appState.swVersion;
export const selectIsSavingReview = (state) => state.appState.isSavingReview;
export const selectCurrentPeriod = (state) => state.appState.currentPeriod;
export const selectCurrentPeriodId = (state) => state.appState.currentPeriod?.id;
export const selectCurrentPeriodStatus = (state) => state.appState.currentPeriod?.status;
